import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_SEARCHES_REQUIRING_ATTENTION } from './types';

import { searchesRequiringAttentionSuccess, searchesRequiringAttentionFailure } from './reducer';
import { CLOSE_COLLECTIVE_ACTIVITIES_MODAL } from '../../activities/types';

const logger = new Logger('Saga:Dashboard:RequiringAttention');

export function* getSearchesRequiringAttention() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard.searches_requiring_attention'),
    );

    logger.info('Got searches requiring attention data');
    yield put(searchesRequiringAttentionSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(searchesRequiringAttentionFailure(error));
  }
}

export default function* searchesRequiringAttentionSaga() {
  return yield all([
    takeLatest(REQUEST_SEARCHES_REQUIRING_ATTENTION, getSearchesRequiringAttention),
    takeLatest(CLOSE_COLLECTIVE_ACTIVITIES_MODAL, getSearchesRequiringAttention),
  ]);
}
